define('models/pages/dashboard/balance',[
    'models/base/model',
    'models/base/collection',
    'lib/utils'
], function(Model) {
    'use strict';

    var BalanceModel = Model.extend({
        defaults: {
            caption: 'Баланс',
            value: '0',
            currencyCode: ''
        },
        constructor: function() {
            Model.apply(this, arguments);
            // this.items = new Collection(data ? data.items : [], { parse: true });
        },
        parse: function(data) {
            return data.items[0];
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            return params;
        }
    });

    return BalanceModel;
});
